@if (title() || showCloseButton()) {
  <div class="modal-header">
    <div class="modal-header__left">
      @if (title()) {
        <h2 id="modal-title" class="modal-header__title">{{ title() ?? '' | translate }}</h2>
      }
    </div>
    @if (showCloseButton()) {
      <div class="modal-header__right">
        <button
          type="button"
          class="modal-header__close-button"
          (click)="onClose()"
          aria-label="Close modal"
        >
          <div class="modal-header__close-icon">
            <img src="/public/svgs/x-close.svg" alt="close" />
          </div>
        </button>
      </div>
    }
  </div>
}

